import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './ExternalLink.module.scss';

const ExternalLink = ({ children, link, variant, variantInvert, onClick, width, xSpace, ...extra }) => {
  const { isDarkMode } = useTheme();
  return (
    <a
      {...extra}
      data-bem="ExternalLink"
      target="_blank"
      rel="noopener noreferrer"
      href={link}
      onClick={onClick}
      className={cn({
        [CN.component]: true,
        [CN[`${variant}Variant`]]: variant,
        [CN[`${width}Width`]]: width,
        [CN.xSpace]: xSpace,
        [CN.variantInvert]: variantInvert,
        [CN.dark]: isDarkMode,
      })}
    >
      {children}
    </a>
  );
};

export default ExternalLink;
